import { ntbPaymentActionType } from '../../actionTypes';

const initialState = {
  isWhatsappConsentAccepted: true,
  preEligibilityErrorMessage: '',
  panNumber: undefined,
  preEligibleLendersList: undefined,
};

const ntbPayment = (state = initialState, action) => {
  switch (action.type) {
    case ntbPaymentActionType.NTB_PAYMENT_SET_WHATSAPP_CONSENT:
      const { isWhatsappConsentAccepted } = action.payload || {};

      return {
        ...state,
        isWhatsappConsentAccepted,
      };

    case ntbPaymentActionType.NTB_PAYMENT_SET_PRE_ELIGIBLE_LENDERS:
      const { preEligibleLendersList } = action.payload || {};

      return {
        ...state,
        preEligibleLendersList,
      };

    case ntbPaymentActionType.NTB_PAYMENT_SET_PRE_ELIGIBLE_FAILURE_MESSAGE:
      const { preEligibilityErrorMessage } = action.payload || {};

      return {
        ...state,
        preEligibilityErrorMessage,
      };

    case ntbPaymentActionType.NTB_PAYMENT_SET_USER_PAN:
      const { panNumber } = action.payload || {};

      return {
        ...state,
        panNumber,
      };

    default:
      return state;
  }
};

export default ntbPayment;



// WEBPACK FOOTER //
// ./reducer/ntbPayment/index.js